export default __webpack_public_path__ + "static/GraphikBoldItalic-235bd40d2881b1f79296899e001907ed.otf";